/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClassSessionDto,
    ClassSessionDtoFromJSON,
    ClassSessionDtoFromJSONTyped,
    ClassSessionDtoToJSON,
} from './ClassSessionDto';

/**
 * 
 * @export
 * @interface ClassSectionDto
 */
export interface ClassSectionDto {
    /**
     * 
     * @type {string}
     * @memberof ClassSectionDto
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassSectionDto
     */
    isActive?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ClassSectionDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClassSectionDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ClassSectionDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {Array<ClassSessionDto>}
     * @memberof ClassSectionDto
     */
    classSessions?: Array<ClassSessionDto> | null;
}

export function ClassSectionDtoFromJSON(json: any): ClassSectionDto {
    return ClassSectionDtoFromJSONTyped(json, false);
}

export function ClassSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassSectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (json['endDate'] === null ? null : new Date(json['endDate'])),
        'classSessions': !exists(json, 'classSessions') ? undefined : (json['classSessions'] === null ? null : (json['classSessions'] as Array<any>).map(ClassSessionDtoFromJSON)),
    };
}

export function ClassSectionDtoToJSON(value?: ClassSectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'isActive': value.isActive,
        'name': value.name,
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate === null ? null : value.endDate.toISOString()),
        'classSessions': value.classSessions === undefined ? undefined : (value.classSessions === null ? null : (value.classSessions as Array<any>).map(ClassSessionDtoToJSON)),
    };
}

